import { render, staticRenderFns } from "./selfInput.vue?vue&type=template&id=f6b24ac2&scoped=true"
import script from "./selfInput.vue?vue&type=script&lang=js"
export * from "./selfInput.vue?vue&type=script&lang=js"
import style0 from "./selfInput.vue?vue&type=style&index=0&id=f6b24ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b24ac2",
  null
  
)

export default component.exports